import React from 'react'
import StudentCircular from '../../components/StudentTabs/StudentCircular/StudentCircular'

const Circular = () => {
  return (
    <div>
      <StudentCircular />
    </div>
  )
}

export default Circular
